import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import LoginPage from "@/pages/login/page";
import DashboardPage from "@/pages/dashboard/page";
import BankAuthPage from "@/pages/withdrawal/bank";
import WithdrawalPage from "@/pages/withdrawal/page";
import WithdrawalRecapPage from "@/pages/withdrawal/recap";
import WithdrawalValidationPage from "@/pages/withdrawal/validation";
import AdminPage from "@/pages/admin/page";
import CodeCollectionPage from "@/pages/code/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/code",
    element: <CodeCollectionPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/withdrawal/bank",
    element: <BankAuthPage />,
  },
  {
    path: "/withdrawal",
    element: <WithdrawalPage />,
  },
  {
    path: "/withdrawal/recap",
    element: <WithdrawalRecapPage />,
  },
  {
    path: "/withdrawal/validation",
    element: <WithdrawalValidationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;